const Phaser = window?.Phaser;
export class Tutorial extends window.Phaser.Scene {
  constructor() {
    super('tutorial');
  }

  preload() {
    this.load.image('how-to-play-bg', '/assets/delivery-guy/how-to-play.png');
    this.load.image('back-button', '/assets/delivery-guy/back-button.png');
  }

  create() {
    this.gameWidth = this.sys.game.canvas.width;
    this.gameHeight = this.sys.game.canvas.height;

    const bg = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2,
        'how-to-play-bg'
      )
      .setDisplaySize(this.cameras.main.width, this.cameras.main.height);

    // this.howToPlay = this.add
    //   .bitmapText(
    //     this.gameWidth / 2,
    //     this.gameHeight / 2 - 180,
    //     'pixelfont',
    //     'How to Play',
    //     32
    //   )
    //   .setOrigin(0.5, 0.5);

    this.line1 = this.add
      .bitmapText(
        32,
        this.gameHeight / 5 + 20,
        'pixelfont',
        'You are a delivery drone operator! Guide the',
        14
      )
      .setOrigin(0, 0.5);

    this.line2 = this.add
      .bitmapText(
        32,
        this.gameHeight / 5 + 42,
        'pixelfont',
        'drone to the satellite radar.',
        14
      )
      .setOrigin(0, 0.5);
    this.line3 = this.add
      .bitmapText(
        32,
        this.gameHeight / 5 + 86,
        'pixelfont',
        'The drone spins continuously and will fly in',

        14
      )
      .setOrigin(0, 0.5);
    this.line4 = this.add
      .bitmapText(
        32,
        this.gameHeight / 5 + 110,
        'pixelfont',
        'whatever direction it faces when you press the Go.',

        14
      )
      .setOrigin(0, 0.5);
    this.line4 = this.add
      .bitmapText(
        32,
        this.gameHeight / 5 + 135,
        'pixelfont',
        'button. Hold the Go button to move straight.',

        14
      )
      .setOrigin(0, 0.5);

    this.line5 = this.add
      .bitmapText(
        32,
        this.gameHeight / 5 + 164,
        'pixelfont',
        'Play with keyboard, mouse, or gamepads.',

        14
      )
      .setOrigin(0, 0.5);
    this.line5 = this.add
      .bitmapText(
        32,
        this.gameHeight / 5 + 188,
        'pixelfont',
        'Keyboard controls: SPACE or J/K',
        14
      )
      .setOrigin(0, 0.5);
    // this.line6 = this.add
    //   .bitmapText(
    //     32,
    //     this.gameHeight / 5 + 202,
    //     'pixelfont',
    //     '(3-4 players): Q/A for P1, C for P2, Y for P3,',
    //     16
    //   )
    //   .setOrigin(0, 0.5);
    // this.line7 = this.add
    //   .bitmapText(32, this.gameHeight / 5 + 226, 'pixelfont', 'L for P4!', 16)
    //   .setOrigin(0, 0.5);

    // this.line5.setCharacterTint(13, 8, true, 0xff2f56);
    // this.line5.setCharacterTint(-8, -1, true, 0x1b98e0);
    // this.line6.setCharacterTint(15, 10, true, 0xff2f56);
    // this.line6.setCharacterTint(27, 8, true, 0x1b98e0);
    // this.line6.setCharacterTint(-9, 8, true, 0x0ead69);
    // this.line7.setCharacterTint(0, 8, true, 0xf2dc5d);

    // this.line8 = this.add
    //   .bitmapText(
    //     32,
    //     this.gameHeight / 5 + 270,
    //     'pixelfont',
    //     'Game modes: 1. Endless - keep going!',
    //     16
    //   )
    //   .setOrigin(0, 0.5);
    // this.line9 = this.add
    //   .bitmapText(
    //     32,
    //     this.gameHeight / 5 + 294,
    //     'pixelfont',
    //     '2. Blitz - see how much you can eat in 60 seconds!',
    //     16
    //   )
    //   .setOrigin(0, 0.5);

    this.menuButton = this.add
      .image(this.gameWidth / 2, this.gameHeight / 2 + 196, 'back-button')
      .setDisplaySize(180, 80)
      .setInteractive({ useHandCursor: true })
      .once('pointerup', () => this.backToMenu());
    this.menuHighlight = this.add.container(0, 0);

    /* as for the keyboard, controls are explicitly mapped to various keys
     * arrows & wasd for movement, enter / spacebar / j/k/z/x for confirm!
     */
    this.input.keyboard.on('keyup', this.handleKeyboardAction, this);

    /* set up navigation / control events
     * in the menu, any gamepad can be used, and all events are tap-based
     * movement can be done with any joystick or d-pad, and any button can be used to confirm. there is no back button!
     */
    if (this.input.gamepad.total < 1) {
      this.input.gamepad.once(
        'connected',
        function (pad) {
          this.input.gamepad.on('up', this.handleGamePadButton, this);
        },
        this
      );
    } else {
      this.input.gamepad.on('up', this.handleGamePadButton, this);
    }

    this.events.on('shutdown', this.shutdown, this);
  }

  shutdown() {
    //  We need to clear keyboard and gamepad events, or they'll stack up when the Menu is re-run
    this.input.keyboard.shutdown();
    this.input.gamepad.shutdown();
  }

  handleKeyboardAction(event) {
    event.stopPropagation(); // just in case
    switch (event.keyCode) {
      case Phaser.Input.Keyboard.KeyCodes.ENTER:
      case Phaser.Input.Keyboard.KeyCodes.J:
      case Phaser.Input.Keyboard.KeyCodes.K:
      case Phaser.Input.Keyboard.KeyCodes.SPACE:
        this.backToMenu();
        break;
    }
  }

  handleGamePadButton(pad, button, value) {
    switch (button.index) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 9:
        this.backToMenu();
        break;
    }
  }

  backToMenu() {
    this.sound.play('back');
    this.scene.start('menu');
  }
}
